import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './pages/common/App.tsx';
import './index.css';
import { initializeTierEffects } from './lib/common/utils.ts';

function AppWithEffects() {
  useEffect(() => {
    initializeTierEffects();
  }, []);

  return (
    <StrictMode>
      <App />
    </StrictMode>
  );
}

createRoot(document.getElementById('root')!).render(
  <AppWithEffects />
);